var map = {
	"./appinstall-de-3x.avif": 57752,
	"./appinstall-en-3x.avif": 46860,
	"./appinstall-en-USA-3x.avif": 70476,
	"./appinstall-es-3x.avif": 2585,
	"./appinstall-fr-3x.avif": 83411
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18953;